<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="card-group mb-0">
          <div class="card p-2" style="width: 350px; height: 350px">
            <div class="card-header text-center" style="background-color: black;">
              <img src="static/img/logo.png" style="height: 47px; width: 175px"/>
            </div>
            <div class="">
              <br/>
              <hr style="margin-top: -2px; margin-bottom: 25px">

              <div class="input-group mb-1">
                <span class="input-group-addon"><i class="icon-user"></i></span>
                <input type="email" class="form-control" placeholder="Email" v-model="email">
              </div>
              <div class="input-group mb-2">
                <span class="input-group-addon"><i class="icon-lock"></i></span>
                <input type="password" class="form-control" v-on:keyup.enter="login" placeholder="Password"
                       v-model="password">
              </div>

              <div class="row">
                <div class="col-6">
                  <button type="button" class="btn btn-primary px-2" @click="login">Login</button>
                </div>
                <div class="col-6 margin-top-7">
                  Remember
                  <label class="switch switch-default switch-pill switch-primary">
                    <input type="checkbox" class="switch-input" checked="" v-model="remember">
                    <span class="switch-label"></span>
                    <span class="switch-handle"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Login';
  import trans_es from '../translates/es/Login';
  import constants from '../constants'
  import middleware from "../utilities/middlewares";

  export default {
    name: 'Login',
    data() {
      return {
        web_texts: '',
        email: '',
        password: '',
        remember: false,
      }
    },
    created() {
      if (window.localStorage.getItem(constants.STORAGE_TOKEN_KEY) !== null) {
        this.$router.push('select_system');
      }
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.email = window.localStorage.getItem('email');
      this.password = window.localStorage.getItem('password');
    },
    mounted() {
      if (window.localStorage.getItem('email') !== null && window.localStorage.getItem('password') !== null) {
        this.remember = true;
      }
    },
    methods: {
      // Si el remember-me esta activat guardar dades al localStorage
      rememberMe() {
        if (this.remember) {
          window.localStorage.setItem('email', this.email);
          window.localStorage.setItem('password', this.password);
        }
      },
      // El login
      login() {
        var out = this;
        axios.post(constants.OAUTH_SERVER_URL, {
          grant_type: constants.OAUTH_GRANT_TYPE,
          client_id: constants.OAUTH_CLIENT_ID,
          client_secret: constants.OAUTH_CLIENT_SECRET,
          username: out.email,
          password: out.password,
          scope: ''
        }).then(function (res) {
          var token = res.data.access_token;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          window.localStorage.setItem(constants.STORAGE_TOKEN_KEY, token);
          console.log(token);
          out.rememberMe();
          out.$router.push('/');
        }).catch(function (err) {
          out.email = '';
          out.password = '';
          console.log(err.message);
        })
      }
    }
  }
</script>
<style scoped>
  .title-login {
    margin-bottom: 15px
  }

  .margin-top-7 {
    margin-top: 7px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?4ed369c4